module.exports = __webpack_public_path__ + "static/media/wheel-diamond-tread.3c154e5f.png";